<div class="toolbar margin-top-98">
  <dx-button icon="close" [text]="labels.Close" (onClick)="onCloseTab()"></dx-button>
</div>
<div class="grid-wrapper-documentcard">
  <div [hidden]="menuIndex != 0" style="grid-row: 1; grid-column: 1">
    <dx-accordion #accordion [collapsible]="true"
                  [multiple]="true"
                  [animationDuration]="300"
                  [selectedIndex]="0">
      <dxi-item [title]="labels.Details">
        <div class="grid-wrapper-details">
          <div class="row-1">
            <p><b>{{document.Number}} - {{document.Name}}</b></p>
          </div>
          <div style="grid-row: 1; grid-column: 4">
            <dx-check-box [text]="labels.MyFavorite" rtlEnabled="true" [(value)]="isFavorite" (click)="favouriteClick()"></dx-check-box>
          </div>
          <div style="grid-row: 2;grid-column: 1">
            <div>{{this.languageService.LNG("Label.Type")}}</div>
            <dx-select-box [items]="documentTypes"
                           [(value)]="document.DocumentTypeId"
                           [searchEnabled]="true"
                           [showClearButton]="true"
                           readOnly="false"
                           displayExpr="Name"
                           searchExpr="Name"
                           valueExpr="DocumentTypeId"></dx-select-box>
          </div>
          <div style="grid-row: 2;grid-column: 2">
            <div>{{this.languageService.LNG("Label.Category")}}</div>
            <dx-select-box [items]="documentCategories"
                           [(value)]="document.DocumentCategoryId"
                           [searchEnabled]="true"
                           [showClearButton]="true"
                           readOnly="false"
                           displayExpr="Code"
                           searchExpr="Code"
                           valueExpr="DocumentCategoryId"></dx-select-box>
          </div>
          <div style="grid-row: 2;grid-column: 3 / span 2;">
            <div>{{this.languageService.LNG("Label.Tag")}}</div>
            <dx-tag-box [items]="documentTags"
                        readOnly="true"
                        displayExpr="Name"
                        valueExpr="DocumentTagId"
                        [value]="document.DocumentTagIds">
            </dx-tag-box>
          </div>
          <div style="grid-row: 3 / span 2; grid-column: 1 / span 4">
            <div>{{this.languageService.LNG("Label.Description")}}</div>
            <dx-text-area [value]="document.Description" [height]="100" readOnly="true"></dx-text-area>
          </div>
        </div>
      </dxi-item>
      <dxi-item [title]="labels.Codes">
        <app-document-codes [documentId]="document.DocumentId"
                            [usedAsSearchParameters]="true"
                            [codeTreeListHeight]="codeTreeListHeight"
                            (codesList)="setSelectedCodes($event)"
                            [isReadOnly]="true">
        </app-document-codes>
      </dxi-item>
      <dxi-item [title]="labels.Attributes">
        <br>
        <br>
        <br>
        <app-document-card-attributes [documentId]="document.DocumentId"
                                      [editingMode]="editingMode"
                                      [treeListHeight]="treeListHeight"
                                      [usedAsSearchParameters]="true"
                                      [isReadOnly]="true">
        </app-document-card-attributes>
      </dxi-item>
    </dx-accordion>
  </div>
  <app-elevation-section [title]="labels.Preview" style="grid-row: 1; grid-column: 2">
    <dx-button class="show-button" [text]="languageService.LNG('Label.Show')" (onClick)="onShowClicked()" template="btnTemplate">
      <div *dxTemplate="let data of 'btnTemplate'">
        <fa-icon [icon]="faWindowMaximize"></fa-icon>
      </div>
    </dx-button>
    <div>
      <iframe [src]="fileurl" style="width: 100%; height: 900px"></iframe>
    </div>
  </app-elevation-section>
</div>

<dx-popup [showTitle]="true"
          [hideOnOutsideClick]="false"
          [(visible)]="showPopUpImage"
          [fullScreen]="true">
  <div *dxTemplate="let data of 'content'">
    <iframe [src]="fileurl" style="width: 100%; height: 100%"></iframe>
  </div>
</dx-popup>
